var kiloByteSize = 1024;
var units = ['Ko', 'Ko', 'Mo'];
/**
 * Transform byte to kilo or mega format.
 *
 * @param {number} bytesSize - File size in bytes.
 * @returns {string} - String with unit of kilo or mega bytes.
 */
export var computeFileSize = function (bytesSize) {
    var i = Math.floor(Math.log(bytesSize) / Math.log(kiloByteSize));
    var denominator = bytesSize < kiloByteSize ? kiloByteSize : 1;
    var convertSize = (bytesSize / Math.pow(kiloByteSize, i)) / denominator;
    return "".concat(parseFloat(convertSize.toFixed(1)), "\u00A0").concat(units[i]);
};
